module.exports = __webpack_public_path__ + "static/media/br.cc3c3713.png";